/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse20028
 */
export interface InlineResponse20028 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20028
     */
    placeId: string;
}

export function InlineResponse20028FromJSON(json: any): InlineResponse20028 {
    return InlineResponse20028FromJSONTyped(json, false);
}

export function InlineResponse20028FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20028 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'placeId': json['placeId'],
    };
}

export function InlineResponse20028ToJSON(value?: InlineResponse20028 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'placeId': value.placeId,
    };
}


